import * as constants from "../constants/translator";

export const translateText = data => ({
  type: constants.TRANSLATE_TEXT,
  data
});

export const deleteInputText = () => ({
  type: constants.DELETE_INPUT_TEXT
});

export const swapSelectedLanguages = () => ({
  type: constants.SWAP_SELECTED_LANGUAGES
});

export const selectLanguage = language => ({
  type: constants.SELECT_LANGUAGE,
  ...language
});

export const toggleLanguageMenu = () => ({
  type: constants.TOGGLE_LANGUAGE_MENU
});



// WEBPACK FOOTER //
// ./src/actions/translator.js